import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button, Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";
import avatar1 from "../../assets/images/user-dummy-img.jpg";
import ConfigData  from "../../config.json";
import LazyLoad from "react-lazyload";

const GridEmployee = ({data, rowPerPage, onClickTerminate}) => {
    const [gridData, setGridData] = useState([]);
    const [gridSlice, setGridSlice] = useState([]);
    const [gridRange, setGridRange] = useState([]);
    const [inPage, setInPage] = useState(1);
    const [lightBoxIsOpen, setLightBoxIsOpen] = useState(false);
    const [lightBoxImage, setLightBoxImage] = useState("");
    const history = useHistory();

    useEffect(() => {
        setGridData(data);
    }, [data]);

    useEffect(() => {
        const range = calculateRange(gridData, rowPerPage);
        setGridRange([...range]);

        const slice = sliceData(gridData, inPage, rowPerPage);
        setGridSlice([...slice]);
    }, [gridData, setGridRange, inPage, setGridSlice, rowPerPage]);


    const calculateRange = (data, rowsPerPage) => {
        const range = [];
        const num = Math.ceil(data.length / rowsPerPage);
        for(let i = 1; i <= num; i++){
            range.push(i);
        }
        return range;
    };

    const sliceData = (data, page, rowsPerPage) => {
        return data.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    };

    const onClickAdd = () => {
        history.push("/employee/0");
    };

    const onClickDetail = (id) => {
        history.push("/employee/" + id);
    };

    return(
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div id="employeeList">
                        <Button color="success" className='button-floating' onClick={onClickAdd}>
                            <i className="ri-add-fill me-1 align-bottom"></i> Create new employee
                        </Button>
                        <Row className="team-list grid-view-filter">
                            {(gridSlice.length > 0) ? gridSlice.map((item, key) => (
                                <Col key={key}>
                                    <Card className="team-box card-animate cursor-pointer">
                                    {/* <Card className="team-box card-animate cursor-pointer"> */}
                                        <CardBody className="p-4">
                                            <Row className="align-items-center team-row">
                                                {/* <Col className="team-setting">
                                                    <UncontrolledDropdown direction="start" className="col text-end">
                                                        <DropdownToggle tag="a" id={"ddlMenu" + key} role="button">
                                                            <i className=" ri-more-2-fill fs-17"></i>
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem className="dropdown-item remove-list" onClick={ (e) => onClickData(item) }>
                                                                <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>Remove
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </Col> */}
                                                <Col lg={4} className="col">
                                                    <div className="team-profile-img">
                                                        <LazyLoad>
                                                            {/* <div className="avatar-lg img-thumbnail rounded-circle flex-shrink-0">
                                                                <img src={(item.employee_pic !== "") ? ConfigData.IMAGE_URL + item.employee_pic : avatar1} alt="" className="img-emp d-block rounded-circle" />
                                                            </div> */}
                                                            <div className="profile-user flex-shrink-0">
                                                                <img src={(item.employee_pic !== "") ? ConfigData.IMAGE_URL + item.employee_pic : avatar1} alt="" className="rounded-circle avatar-xl img-thumbnail user-profile-image d-block" />
                                                            </div>
                                                        </LazyLoad>
                                                        <div className="team-content">
                                                            <h5 className="fs-14 mb-1">{item.name_th + " " + item.surname_th}</h5>
                                                            <h5 className="fs-14 mb-1">{item.name_en + " " + item.surname_en}</h5>
                                                            <p className="text-muted mb-1">{(item.employee_id === "") ? "-" : item.employee_id}</p>
                                                            <p className="text-muted mb-1">{(item.name_position === "") ? "-" : item.name_position}</p>
                                                            <p className="text-muted mb-3">{(item.office_email === "") ? "-" : item.office_email}</p>
                                                            {/* <p className="text-muted mb-1">{(item.phone_number === "") ? "-" : item.phone_number}</p> */}
                                                            <div className="d-grid gap-2 mt-3">
                                                                <Button color="primary" onClick={(e) => { onClickDetail(item.id); }}>See more</Button>
                                                                <Button color="light" onClick={(e) => { onClickTerminate(item.id); }}>Terminate</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )) :<Col style={{width: "100%"}}>
                                    <Card className="team-box">
                                        <CardBody className="p-4">
                                            <Row className="align-items-center team-row">
                                                <Col lg={12} className="col"><h6>No employee</h6></Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col> 
                            }
                        </Row>
                    </div>
                </Col>
            </Row>
            <div className="align-items-center justify-content-center d-flex">
                <ul className="pagination pagination-separated mb-3">
                    <li className="page-item">
                        <Link to="#" className="page-link" onClick={() => { setInPage(1); }}>First</Link>
                    </li>
                    <li className="page-item">
                        <Link to="#" className="page-link" onClick={() => { setInPage((inPage - 1 <= 0) ? 1 : inPage - 1 ); }}>←</Link>
                    </li>
                    {gridRange.map((val, key) => {
                        return (
                            <li key={key} className={"page-item" + (inPage === val ? " active" : "")}>
                                <Link to="#" className="page-link" onClick={() => { setInPage(val); }}>{val}</Link>
                            </li>
                        );
                    })}
                    <li className="page-item">
                        <Link to="#" className="page-link" onClick={() => { setInPage((inPage + 1 >= gridRange.length) ? gridRange.length : inPage + 1 ); }}>→</Link>
                    </li>
                    <li className="page-item">
                        <Link to="#" className="page-link" onClick={() => { setInPage(gridRange.length); }}>Last</Link>
                    </li>
                </ul>
            </div>
        </React.Fragment>
    );
};

export default GridEmployee;









